/*jslint browser: true */
"use strict";

var $ = require("pli/jquery");
var Slick = require("slickgrid/core");


//-------------------------------------------
function AlternateRowSelectionModel() {
    /// <summary>Pli row selection plug-in for slick grid</summary>

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Private Members

    var self = {},
        /// <summary>The current instance of the plug-in.</summary>

        selectedRows = [],
        /// <summary>The array containing the rows that are currently selected.</summary>

        selectedRanges = [],
        /// <summary>The array containing the ranges (Slick.range) that are currently selected.</summary>

        pivotRow,
        /// <summary>Determines the row to pivot shift+(up|down) from.</summary>

        grid;
        /// <summary>The current instance of slick.grid</summary>



    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Private Methods
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    //-------------------------------------------
    function calculateItemsPerPage() {
        var $container = $(grid.getCanvasNode()).parent(),
            height = $container && $container.height(),
            options = grid.getOptions(),
            rowHeight = options && options.rowHeight;
        if (height > 0 && rowHeight > 0) {
            return Math.floor(height / rowHeight) - 2; // 1 less row than a page and also exclude header
        }
        return 0;
    }


    //-------------------------------------------
    function toRows(sourceRanges) {
        /// <summary>Converts an array of ranges to an array of rows.</summary>
        var rows = [], i, j, range;
        for (i = 0; i < sourceRanges.length; i = i + 1) {
            range = sourceRanges[i];
            for (j = range.fromRow; j <= range.toRow; j = j + 1) {
                rows.push(j);
            }
        }
        return rows;
    }


    //-------------------------------------------
    function toRanges(sourceRows) {
        /// <summary>Converts an array of rows to an array of ranges.</summary>
        var ranges = [], i, row;
        for (i = 0; i < sourceRows.length; i = i + 1) {
            row = sourceRows[i];
            ranges.push(new Slick.Range(row, 0, row, grid.getColumns().length - 1));
        }
        return ranges;
    }


    //-------------------------------------------
    function calculateRange(start, end) {
        /// <summary>Calculates the includes items from start position to end position inclusive.</summary>
        /// <param name="from">The starting position to calculate from</param>
        /// <param name="to">The end position to calculate to</param>
        var i, range = [];

        // start is less than end (create array start - end)
        if (start < end) {
            for (i = start; i <= end; i = i + 1) {
                range.push(i);
            }

        // start is greater than end (create array end - start)
        } else if (start > end) {
            for (i = start; i >= end; i = i - 1) {
                range.push(i);
            }

        // start equals end (create an array containing either)
        } else {
            range.push(end);
        }

        return range;
    }


    //-------------------------------------------
    function nextActiveRow(currentRow, cell, increment, canSelect) {
        /// <summary>Gets the next focusable row relative to the current row.</summary>
        /// <returns>the current cell or the next focusable cell.  null if there is not a focusable.</returns>
        var row = currentRow,
            i = 1;

        canSelect = grid.getOptions().multiSelect !== true ? grid.canCellBeSelected : canSelect || grid.canCellBeActive;
        while (canSelect(row, cell) !== true) {
            row = increment(row, i);
            if (row >= grid.getDataLength() || row < 0) {
                row = null;
                break;
            }
            i = i + 1;
        }

        return row;
    }


    //-------------------------------------------
    function resolveSelection(row, cell) {
        /// <summary>Resolves the selected rows for the current row.</summary>
        var rows = [],
            gridData = grid.getData(),
            metaData;

        // Add the current row if it is selectable
        if (grid.canCellBeSelected(row, cell)) {
            rows.push(row);
        }

        // Check for a select function on meta data and add results.
        if ($.isFunction(gridData.getItemMetadata)) {
            metaData = gridData.getItemMetadata(row);
            if ($.isPlainObject(metaData) === true && typeof metaData.select === "function") {
                rows = rows.concat(metaData.select());
            }
        }

        return rows;
    }


    //-------------------------------------------
    function calculateSelection(pivot, rows) {
        /// <summary>Calculates the selection between the pivot and the rows specified.</summary>
        var result;

        // the active row is after the selection.
        if (pivot > rows[rows.length - 1]) {
            result = calculateRange(pivot, rows[0]);

        // the active row is before the selection.
        } else if (pivot < rows[0]) {
            result = calculateRange(pivot, rows[rows.length - 1]);

        // the active cell is within the selected rows.
        } else {
            result = rows;
        }

        return result;
    }


    //-------------------------------------------
    function toggleSelected(rows, selection, forceSelected) {
        /// <summary>updates the rows passed in and adds the selection
        /// if the first row is not in the rows collection otherwise
        /// removes the selection from the rows collection</summary>
        var position;

        // handle single selection.
        if (grid.getOptions().multiSelect !== true) {
            if (rows[0] === selection[0]) {
                rows = [];
            } else {
                rows = $.extend(true, [], selection);
            }
            return rows;
        }

        // if the first value in the selection is selected then remove all in selection
        if ($.inArray(selection[0], rows) > -1 && forceSelected !== true) {
            $.each(selection, function eachSelection() {
                position = $.inArray(this, rows);
                if (position > -1) {
                    rows.splice(position, 1);
                }
            });

        // otherwise first value is not selected so add all in the selection
        } else {
            $.each(selection, function eachSelection() {
                rows.push(this);
            });
        }
        return rows;

    }


    //-------------------------------------------
    function move(e, increment, canSelect) {
        /// <summary>Handle keyboard event</summary>
        /// <param name="canSelect">The delegate that accepts (row, cell) and returns true or
        /// false whether this cell can be selected.</param>
        var activeCell = grid.getActiveCell(),
            targetRow,
            isMultiSelect = grid.getOptions().multiSelect !== false;

        if (activeCell === undefined || activeCell === null) {
            return false;
        }

        targetRow = nextActiveRow(increment(activeCell.row, 0), activeCell.cell, increment, canSelect);
        if (targetRow === undefined || targetRow === null) {
            return false;
        }

        // select everything from pivot cell to target cell.
        if (e.shiftKey === true && isMultiSelect === true) {
            pivotRow = typeof pivotRow === "number" ? pivotRow : activeCell.row;
            self.setSelectedRows(calculateSelection(pivotRow, resolveSelection(targetRow, activeCell.cell)));
            self.onSelectedReset.notify();

        // clear selection and select current cell.
        } else if (e.ctrlKey !== true) {
            self.setSelectedRows(resolveSelection(targetRow, activeCell.cell));
            pivotRow = targetRow;
            self.onSelectedReset.notify();
        }

        grid.setActiveCell(targetRow, activeCell.cell);
        if (!grid.getActiveCell()) { grid.setActiveCell(targetRow, 0); }
        e.stopImmediatePropagation();
    }



    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Event Handlers
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    //-------------------------------------------
    function handleClick(e) {
        /// <summary>Handles the click event of the slick.grid</summary>
        var clickedCell = grid.getCellFromEvent(e),
            clickedRow = nextActiveRow(clickedCell.row, clickedCell.cell, function next(i) {
                return i + 1;
            }),
            activeCell,
            selection = resolveSelection(clickedRow, clickedCell.cell),
            rows,
            isMultiSelect = grid.getOptions().multiSelect !== false;

        if (selection.length <= 0) {
            grid.setActiveCell(clickedRow, clickedCell.cell);
            e.stopImmediatePropagation();
            return false;
        }

        // (ctrl+shift) - retain current selection and select everything up to and including last selected item.
        if (e.ctrlKey === true && e.shiftKey === true && isMultiSelect === true) {
            activeCell = grid.getActiveCell();
            rows = selectedRows.concat(calculateSelection(activeCell.row, selection));


        // (ctrl) - retain current selection and toggle selection of current item.
        } else if (e.ctrlKey === true) {
            rows = $.extend(true, [], selectedRows);
            rows = toggleSelected(rows, selection);
            pivotRow = clickedRow;


        // (shift) - clear current selection and select everything up to and including last selected item.
        } else if (e.shiftKey === true && isMultiSelect === true) {
            activeCell = grid.getActiveCell();
            rows = calculateSelection(typeof pivotRow === "number" ? pivotRow : activeCell.row, selection);
            self.onSelectedReset.notify();


        // (no modifier key) - clear current selection and select current item.
        } else {
            rows = selection;
            pivotRow = clickedRow;
            self.onSelectedReset.notify();
        }

        grid.setActiveCell(clickedRow, clickedCell.cell);
        self.setSelectedRows(rows);
        e.stopImmediatePropagation();

    }


    //-------------------------------------------
    function handleKeyDown(e) {
        /// <summary>Handles the keydown event of the slick.grid</summary>
        var activeCell = grid.getActiveCell(),
            selection,
            isMultiSelect = grid.getOptions().multiSelect !== false;

        if (activeCell === undefined || activeCell === null) {
            return false;
        }


        switch (e.which) {

        // space
        case 32:
            selection = resolveSelection(activeCell.row, activeCell.cell);
            selectedRows = toggleSelected(selectedRows, selection, e.ctrlKey !== true);
            pivotRow = activeCell.row;
            self.setSelectedRows(selectedRows);
            e.stopImmediatePropagation();
            break;

        // up arrow
        case 38:
        case 104:
            move(e, function increment(i) {
                return i - 1;
            });
            break;

        // down arrow
        case 40:
        case 98:
            move(e, function increment(i) {
                return i + 1;
            });
            break;

        // home
        case 36:
            move(e, function increment(position, i) {
                return (i === 0) ? 0 : position + 1;
            }, grid.canCellBeSelected);
            break;

        // end
        case 35:
            move(e, function increment(position, i) {
                return (i === 0) ? grid.getDataLength() - 1 : position - 1;
            }, grid.canCellBeSelected);
            break;

        // pageup
        case 33:
            move(e, function increment(position, i) {
                return (i === 0) ? Math.max(0, position - calculateItemsPerPage()) : position + 1;
            }, grid.canCellBeSelected);
            break;

        // pagedown
        case 34:
            move(e, function increment(position, i) {
                return (i === 0) ? Math.min((grid.getDataLength() - 1), position + calculateItemsPerPage()) : position - 1;
            }, grid.canCellBeSelected);
            break;

        // ctrl + a
        case 65:
            if (e.ctrlKey === true && isMultiSelect) {
                self.setSelectedRows(calculateRange(0, grid.getDataLength() - 1));
                e.stopImmediatePropagation();
            }
            break;

        }

    }



    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Public Api
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    //-------------------------------------------
    function getSelectedRows() {
        /// <summary>Gets the current array of rows that are selected.</summary>
        return selectedRows;
    }


    //-------------------------------------------
    function setSelectedRows(rows) {
        /// <summary>Sets the array of rows that are currently selected.</summary>
        if (grid.getOptions().multiSelect !== true) {
            selectedRows = rows.length > 0 ? [rows[0]] : rows;
        } else {
            selectedRows = rows;
        }
        selectedRanges = toRanges(selectedRows);
        self.onSelectedRangesChanged.notify(selectedRanges);
    }


    //-------------------------------------------
    function getSelectedRanges() {
        /// <summary>Gets the current array of ranges that are selected.</summary>
        return selectedRanges;
    }


    //-------------------------------------------
    function setSelectedRanges(ranges) {
        /// <summary>Sets the array of ranges that are currently selected.</summary>
        self.setSelectedRows(toRows(ranges));
    }


    //-------------------------------------------
    function init(sourceGrid) {
        /// <summary>Initialize the pli row selection plug-in.</summary>
        /// <param name="grid">The current instance of slick.grid</param>
        grid = sourceGrid;
        grid.onClick.subscribe(handleClick);
        grid.onKeyDown.subscribe(handleKeyDown);
    }


    //-------------------------------------------
    function destroy() {
        /// <summary>De-initialize the row selection plug-in.</summary>
        grid.onClick.unsubscribe(handleClick);
        grid.onKeyDown.unsubscribe(handleKeyDown);
    }


    self = $.extend(self, {

        //-------------------------------------------
        getSelectedRanges: getSelectedRanges,

        //-------------------------------------------
        setSelectedRanges: setSelectedRanges,

        //-------------------------------------------
        getSelectedRows: getSelectedRows,

        //-------------------------------------------
        setSelectedRows: setSelectedRows,

        //-------------------------------------------
        init: init,

        //-------------------------------------------
        destroy: destroy,

        //-------------------------------------------
        onSelectedRangesChanged: new Slick.Event(),

        //-------------------------------------------
        onSelectedReset: new Slick.Event()
        /// <summary>triggers whenever the selected rows are cleared</summary>

    });


    return self;

}

module.exports = AlternateRowSelectionModel;



//////////////////
// WEBPACK FOOTER
// ./app/slickgrid/slick.alternaterowselectionmodel.js
// module id = 523
// module chunks = 49